const handler = ( $ ) => {
	// All images
	const $image = $( 'img', '.rich-text-editor' );

	if ( $image.length == 0 ) {
		return;
	}

	$image.each( ( _, img ) => {
		const $img = $( img );
		const classes = $img.attr( 'class' );
		console.log( classes );

		$img.attr( 'class', '' )
			.attr( 'style', '' )
			.wrap( `<div class="${ classes } wp-img-wrapper"></div>` );
	} );

	// Images with caption
	const $captionedImgWrapper = $(
		'.wp-img-wrapper',
		'.rich-text-editor .wp-caption'
	);

	if ( $captionedImgWrapper.length == 0 ) {
		return;
	}

	$captionedImgWrapper.each( ( _, wrapper ) => {
		const $wrapper = $( wrapper );
		const classes = $wrapper.attr( 'class' );
		const $decoreBefore = $( '<div class="wp-img-decore-before"></div>' );
		const $decoreAfter = $( '<div class="wp-img-decore-after"></div>' );

		$wrapper
			.attr( 'class', ` ${ classes } wp-img-wrapper--decorated` )
			.prepend( $decoreBefore )
			.append( $decoreAfter );
	} );

	// Fix for decoration of images with caption
	const baseImageWidth = 920;
	const $decorWrapper = $( '.wp-img-wrapper--decorated' );

	$decorWrapper.each( function ( _, element ) {
		const wrapperWidth = $( element ).width();
		// After
		const $decoreAfter = $( '.wp-img-decore-after', element );
		const decoreAfterTop = parseInt( $decoreAfter.css( 'top' ) );
		const decoreAfterRight = parseInt( $decoreAfter.css( 'right' ) );
		const decoreAfterWidth = $decoreAfter.width();
		const decoreAfterHeight = $decoreAfter.height();

		// Before
		const $decoreBefore = $( '.wp-img-decore-before', element );
		const decoreBeforeBottom = parseInt( $decoreBefore.css( 'bottom' ) );
		const decoreBeforeLeft = parseInt( $decoreBefore.css( 'left' ) );
		const decoreBeforeWidth = $decoreBefore.width();
		const decoreBeforeHeight = $decoreBefore.height();

		if ( wrapperWidth < baseImageWidth ) {
			let scaleFactor = baseImageWidth / wrapperWidth;

			$decoreAfter
				.width( decoreAfterWidth / scaleFactor )
				.height( decoreAfterHeight / scaleFactor )
				.css( {
					top: decoreAfterTop / scaleFactor,
					right: decoreAfterRight / scaleFactor,
				} );

			$decoreBefore
				.width( decoreBeforeWidth / scaleFactor )
				.height( decoreBeforeHeight / scaleFactor )
				.css( {
					bottom: decoreBeforeBottom / scaleFactor,
					left: decoreBeforeLeft / scaleFactor,
				} );
		}
	} );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
